// extracted by mini-css-extract-plugin
export default {"row":"_2xNEd","textNoMargin":"_1YuZm","textLineHeight":"IXFsC","preWrap":"_5mYF4","ellipsis":"BJX65"};